<template>
  <span>
  <span v-if="this.size === 'xs'">{{ language.toLowerCase() }}-{{ country.toUpperCase() }}</span>
  <span v-else-if="this.size === 'sm'">{{ language.toLowerCase() }} - {{ country.toUpperCase() }}</span>
  <span v-else>
    {{ languageFullName }} ({{ countryFullName }})
  </span>
  </span>
</template>

<script>
export default {
  name: 'GeoLangName',
  props: ['country', 'language', 'size'],
  computed: {
    countryFullName () {
      return this.$locale.countryCodeToName(this.country)
    },
    languageFullName () {
      return this.$locale.languageCodeToName(this.language)
    },
  }
}
</script>